import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import { whitepapers } from "./whitepaperData";
import WhitepaperModal from "./whitepaperpopup/WhitepaperModal";

const WhitepaperDetails = () => {
  const { slug } = useParams();
  const whitepaper = whitepapers.find((item) => item.slug === slug);
  const [showWhitepaperModal, setShowWhitepaperModal] = useState(false);

  if (!whitepaper) {
    return (
      <Container className="py-5 text-center">
        <h2>Whitepaper not found</h2>
        <p>The selected whitepaper could not be found.</p>
        <Link to="/white-papers" className="btn btn-dark">
          Back to Whitepapers
        </Link>
      </Container>
    );
  }

  return (
    <>
      <style>{`
        .whitepaper-detail {
          font-family: 'Outfit', sans-serif;
          background: #fff;
          color: #0f172a;
        }
        .hero {
          padding: 80px 0 80px;
          text-align: center;
          background: #effdff;
        }
        .hero h1 {
          color: #0f172a;
          font-size: 2.6rem;
          font-weight: 800;
        }
        .hero p {
          color: #475569;
          font-size: 1.2rem;
          max-width: 900px;
          margin: 0 auto;
        }
        .content {
          padding: 40px 0;
        }
        .whitepaper-image {
          width: 100%;
          border-radius: 12px;
          object-fit: cover;
          max-height: 500px;
        }
        .whitepaper-details p {
          margin-bottom: 16px;
        }
        .actions {
          margin-top: 26px;
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
        .actions button,
        .actions a {
          padding: 10px 16px;
          font-weight: 700;
          border-radius: 10px;
          border: 0;
          color: #fff;
          text-decoration: none;
          cursor: pointer;
        }
        .actions .download {
          background: #ee0000;
        }
        .actions .back {
          color: #e00;
          background: #fff;
          border: 1px solid #e00;
        }

        @media (max-width: 768px) {
          .hero h1 {
            font-size: 2rem;
          }
          .hero p {
            font-size: 1rem;
          }
          .actions {
            flex-direction: column;
          }
          .actions button,
          .actions a {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>

      <div className="whitepaper-detail">
        <section className="hero">
          <Container>
            <h1>{whitepaper.title}</h1>
            <p>{whitepaper.excerpt}</p>
          </Container>
        </section>

        <Container className="content">
          <img
            src={whitepaper.image}
            alt={whitepaper.title}
            className="whitepaper-image"
          />
          <div className="whitepaper-details mt-4">
            {whitepaper.details.map((detail, idx) => (
              <p key={idx}>{detail}</p>
            ))}
          </div>

          <div className="actions">
            <button
              className="download"
              onClick={() => setShowWhitepaperModal(true)}
            >
              Download Whitepaper
            </button>
            <Link to="/white-papers" className="back">
              <ArrowRight size={14} /> Back to Whitepapers
            </Link>
          </div>
        </Container>

        <WhitepaperModal
          show={showWhitepaperModal}
          onHide={() => setShowWhitepaperModal(false)}
          whitepaperTitle={whitepaper.title}
          whitepaperPdfFile={whitepaper.pdfFile}
        />
      </div>
    </>
  );
};

export default WhitepaperDetails;
